import React, { Component } from 'react';
import { Form, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import { Redirect } from "react-router-dom";
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import { cloneDeep, isEmpty } from 'lodash';
import "./index.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class UpdateTTSFlow extends Component {
    constructor(props) {
        super(props);
        let sitePath;
        let filePath;

        const protocol = window.location.protocol;
        const slashes = protocol.concat("//");
        sitePath = slashes.concat(window.location.hostname);
        this.state = {
            userId: props.app.userId,
            apiPath: props.app.apiPath,
            sitePath: sitePath,
            filePath: filePath,
            webhookAdded: false,
            mobile: '',
            eventList: [],
            webhookname: '',
            webhookurl: '',
            eventName: '',
            ttsTemplateType: '',
            language: '',
            gender: '',
            selectedType: 'variable',
            selectedPromptId: '',
            promptUploads: [],
            ttsTypeListApi: [],
            showTTSTable: false,
            selectedValue: '',
            valueList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            totalVariable:'',
            ttsRows: [],
            ttsList: [],
            templateId: '',
            dtmf: '',
            menuId: '',
            menuWaitTime: '',
            rePrompt: '',
            prompt: true,
            welcomePrompt: false,
            menuPrompt: true,
            noinputPrompt: false,
            wronginputPrompt: false,
            thanksPrompt: false,
            agentRows: [],
            groupAgentList: [],
            smsApiSuccess: '',
            smsSuccessMessage: '',
            smsSuccessType: '',
            smsSuccessPayload: '',
            smsApiFail: '',
            smsFailMessage: '',
            smsFailType: '',
            smsFailPayload: '',
            smsApiDtmf: '',
            smsDtmfMessage: '',
            smsDtmfPayload: '',
            smsFailType: '',
            callDurationSMS: 0,
            smsWebhookList: [],
            smsWebhookFlag: false,
            callPatchSuccessMessage: '',
            callPatchFailMessage: '',
            callPatchSuccessType: '',
            callPatchFailType: '',
            callPatchSuccessPayload: '',
            callPatchFailPayload: '',
            moduleList: [],
            retryFlag: false,
            webhookFlag: false,
            ttsFlag: false,
            smsWebhookFlag: false,
            webhookList: [],
            flowAdded: false,
            ttsFlowName: '',
            ttsDetails: '',
            languageValue: '',
            templateIdValue: '',
            welcomePromptName: '',
            menuPromptName: '',
            noInputPromptName: '',
            wrongInputPromptName: '',
            thanksPromptName: '',
            welcomeId: '',
            noInputId: '',
            wrongInputId: '',
            thanksId: '',
            menuId: '',
            noAgentId: '',
            ivrList: [],
            ivrId: '',
            ivrFlag: '',
            customIvrFlag: false,
            startDate: '',
            endDate: '',
            startTime: '',
            endTime: '',
            campaignIds:''
        }

    }

    componentDidMount() {
        const apiPath = this.state.apiPath;
        const userId = this.state.userId;

        const ttsFlowId = this.props.ttsFlowId;
        Fetcher.get(apiPath + `/api/obd/get/tts/flow/${ttsFlowId}`)
            .then(res => {
                
                const ttsFlow = JSON.parse(res.ttsFlow);
                
                const templateData = JSON.parse(res.templateData);
                let agentRows = []
                if (res.agentRows) {
                    agentRows = JSON.parse(res.agentRows);
                }

                if (res.ivrId != undefined && res.ivrId != "") {
                    this.state.ivrFlag = true;
                    this.state.ivrId = res.ivrId;
                }

                console.log("comes1");

                const smsData = JSON.parse(res.smsData);

                console.log("************ : " + JSON.stringify(ttsFlow))

                let language = "";
                if (ttsFlow.language === "en-IN") {
                    language = "English";
                } else {
                    language = "Hindi";
                }

                console.log("comes2");

                let templateIdValue = "";
                if (res.templateId == "7") {
                    templateIdValue = "TTS Simple IVR";
                } else if (res.templateId == "8") {
                    templateIdValue = "TTS DTMF";
                }
                else if (res.templateId == "9") {
                    templateIdValue = "TTS Call Patch";
                }

                console.log(">>>>>> : " + JSON.stringify(ttsFlow.ttsRows));
                const tts = JSON.parse(JSON.stringify(ttsFlow.ttsRows));
                //const agent = JSON.parse(agentRows.patchList);
                console.log("comes4 : " + tts.ttsList);
                let ttsListObj = {
                    "ttsList": tts.ttsList
                }

                //const sdate = this.convertDateFormat(res.startDate);
                //const edate = this.convertDateFormat(res.enddate);

                console.log("... s : "+res.startDate);

                console.log(":::::::::: " + ttsListObj)
                this.setState({
                    ttsDetails: res,
                    ttsFlowName: res.ttsFlowName,
                    language: language,
                    languageValue: ttsFlow.language,
                    gender: ttsFlow.gender,
                    templateId: res.templateId,
                    templateIdValue: templateIdValue,
                    ttsRows: tts.ttsList,
                    ttsList: ttsListObj,
                    dtmf: templateData.dtmf,
                    menuId: templateData.menuPId,
                    menuWaitTime: templateData.menuWaitTime,
                    rePrompt: templateData.rePrompt,
                    noInputId: templateData.noInputPId,
                    noinputPrompt: (!!templateData.noInputPId ? true : false),
                    wrongInputId: templateData.wrongInputPId,
                    wronginputPrompt: (templateData.wrongInputPId ? true : false),
                    welcomeId: templateData.welcomePId,
                    thanksId: templateData.thanksPId,
                    thanksPrompt: (templateData.thanksPId ? true : false),
                    noAgentId: templateData.noAgentId,
                    noAgentPrompt: (templateData.noAgentPrompt ? true : false),
                    agentRows: agentRows.patchList ?? [],
                    patchList: agentRows ?? [],
                    sendWebhook: smsData.webhook,
                    webhookId: (smsData.webhookId),
                    sendSmsSuccess: (smsData.smsSuccessApi.length > 0 ? true : false),
                    sendSmsFail: ((smsData.smsFailApi.length > 0 ? true : false)),
                    sendSmsDtmf: ((smsData.smsDtmfApi.length > 0 ? true : false)),
                    sendSmsPatchFail: ((smsData.callPatchFailMessage.length > 0 ? true : false)),
                    sendSmsPatchSuccess: ((smsData.callPatchSuccessMessage.length > 0 ? true : false)),
                    callDurationSMS: smsData.callDurationSMS,
                    startDate : (res.startDate == '') ? new Date() : new Date(res.startDate),
                    endDate:  (res.endDate == '') ? new Date() : new Date(res.endDate),
                    startTime : res.startTime,
                    endTime : res.endTime,
                    campaignIds: res.campaignIds
                })

                let newArr = [];
                this.state.ttsRows.map((item, index) => {
                    newArr = this.state.valueList.filter(val => {
                        return !this.state.ttsRows.some(row =>
                            row.ttsType === "variable" && Number(row.value) === val
                        );
                    });
                });

                console.log("comes3");

                this.setState({ valueList: newArr });

            })
            .catch(err => { console.log('Error in fetching TTS Flow Details', err) });

        // Get PromptUpload Files List
        Fetcher.get(apiPath + '/api/obd/prompts/' + userId)
            .then(res => {
                this.setState({
                    promptUploads: res
                })

            })
            .catch(err => { console.log('Error in fetching PromptUpload Files', err) });

        Fetcher.get(apiPath + '/api/obd/tts/type/list')
            .then(res => {
                this.setState({
                    ttsTypeListApi: res
                })
                console.log("TTS Type List : " + JSON.stringify(this.state.ttsTypeListApi));

            })
            .catch(err => { console.log('Error in fetching TTS Type List', err) });

        // Get Group Agent List
        Fetcher.get(apiPath + '/api/obd/group/agent/list/' + userId)
            .then(res => {
                this.setState({
                    groupAgentList: res
                })
            })
            .catch(err => { console.log('Error in fetching Group Agent\'s', err) });

        // Get User Module List
        Fetcher.get(apiPath + '/api/obd/module/list/' + userId)
            .then(res => {
                this.setState({
                    moduleList: res
                })
                if (!isEmpty(this.state.moduleList) && (!('error' in this.state.moduleList))) {
                    this.state.moduleList.map((fileObj) => {
                        if (fileObj.moduleName === 'Auto Retry Campaign') {
                            this.state.retryFlag = true;
                        }
                        else if (fileObj.moduleName === 'Webhooks') {
                            this.state.webhookFlag = true;
                        }
                        else if (fileObj.moduleName === 'TTS') {
                            this.state.ttsFlag = true;
                        }
                        else if (fileObj.moduleName === 'SMS Webhooks') {
                            this.state.smsWebhookFlag = true;
                        }
                        else if (fileObj.moduleName === 'Custom IVR') {
                            this.state.customIvrFlag = true;
                        }
                    })
                }
            })
            .catch(err => { console.log('Error in fetching Modules', err) });


        // Get IVR List
        Fetcher.get(apiPath + '/api/obd/custom/ivr/list/'+userId)
                        .then(res => {
                            this.setState({
                                ivrList: res
                            })
                        })
                        .catch(err => { console.log('Error in fetching IVR List', err) });
        


        Fetcher.get(apiPath + '/api/obd/webhooks/' + userId)
            .then(res => {
                this.setState({
                    webhookList: res
                })

            })
            .catch(err => { console.log('Error in fetching Modules', err) });

        this.getSmsWebhooklist();

        Fetcher.get(apiPath + '/api/obd/user/profile/' + userId)
            .then(res => {
                this.setState({

                    totalVariable: res?.totalVariable || ""
                })
            })
            .catch(err => { console.log('Error in fetching Users data', err) });

    }

    convertDateFormat = (date1) => {

        const originalDateStr = date1; // YYYY:DD:MM HH:MM:SS

        // Split into components
        const [datePart, timePart] = originalDateStr.split(' ');
        const [year, day, month] = datePart.split(':');

        // Reconstruct a date string in ISO-compatible order (YYYY-MM-DDTHH:MM:SS)
        const isoLike = `${year}-${month}-${day}T${timePart}Z`;

        // Create a Date object
        const date = new Date(isoLike);

        // Convert to full ISO string (with milliseconds)
        const isoString = date.toISOString();

        console.log("^^^^^^^^^ date : " + isoString); // ➜ "2025-08-13T09:30:00.000Z"

        return isoString;


    }

    getSmsWebhooklist = () => {
        const apiPath = this.props.app.apiPath;
        const userId = this.props.app.userId;
        Fetcher.get(apiPath + '/api/obd/sms/webhooks/' + userId)
            .then(res => {
                this.setState({
                    smsWebhookList: res
                })
            })
            .catch(err => { console.log('Error in fetching sms webhooks', err) });
    }

    toggleChange = (e, name) => {
        this.setState({
            [name]: !this.state[name],
        });
    }

    getPromptName = (pid) => {
        let pName = "";
        if (!isEmpty(this.state.promptUploads) && (!('error' in this.state.promptUploads))) {

            const match = this.state.promptUploads.find(fileObj =>
                (pid == fileObj.promptId)
            );
            if (match) {
                pName = match.fileName;
            }
        }
        return pName;
    }


    getWebhookName = (wid) => {
        let wName = "";
        if (!isEmpty(this.state.webhookList) && (!('error' in this.state.webhookList))) {

            const match = this.state.webhookList.find(fileObj =>
                (wid == fileObj.id)
            );
            if (match) {
                wName = match.webhookName;
            }
        }
        return wName;
    }

    getIVRName = (wid) => {
        console.log("************ " + wid);
        let wName = "";
        if (!isEmpty(this.state.ivrList) && (!('error' in this.state.ivrList))) {

            const match = this.state.ivrList.find(fileObj =>
                (wid == fileObj.id)
            );
            if (match) {
                wName = match.flowName;
            }
        }
        return wName;
    }


    setvalue = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    }

    setMessageShow = (status) => {
        this.setState({
        });
    }


    handleSelect = function (selectedItems) {
        const dtmfSelected = [];
        for (let i = 0; i < selectedItems.length; i++) {
            dtmfSelected.push(selectedItems[i].value);
        }
        this.setState({
            dtmf: dtmfSelected.toString()
        });
    }


    getFormatedDate = (reqDate) => {

        let date = '';
        if (reqDate != '') {
            date = new Date(reqDate);
        } else {
            date = new Date();
        }
        let sendDateTime = this.addZero(date.getFullYear());
        sendDateTime += "-";
        sendDateTime += this.addZero((date.getMonth() + 1));
        sendDateTime += "-"
        sendDateTime += this.addZero(date.getDate());
        /*sendDateTime += " "
        sendDateTime += this.addZero(date.getHours());
        sendDateTime += ":"
        sendDateTime += this.addZero(date.getMinutes());
        sendDateTime += ":"
        sendDateTime += this.addZero(date.getSeconds());*/

        return sendDateTime;

    }

    handleUpdateTTSFlow = (event) => {
        event.preventDefault();

        const formData = cloneDeep(this.state);
        if (formData.agentRows.length === 0 && formData.templateId === '9') {
            this.setState({ loading: false });
            Notify.notify('Please add Agent and DTMF Row');
            return;
        }

        const formattedStartDate = this.getFormatedDate(this.state.startDate);
        const formattedEndDate = this.getFormatedDate(this.state.endDate);

        if (formattedStartDate == formattedEndDate) {
            this.setState({ loading: false });
            Notify.notify(`Start Date can't be same as End Date `);
            return;
        }

        if (formattedStartDate > formattedEndDate) {
            this.setState({ loading: false });
            Notify.notify(`Start Date can't be greater than End Date `);
            return;
        }
        
        if (this.state.startTime && this.state.endTime) {
            if (this.state.startTime === this.state.endTime) {
                this.setState({ loading: false });
                Notify.notify('Start and end times cannot be the same');
                return;
            }

            if (this.state.startTime > this.state.endTime) {
                this.setState({ loading: false });
                Notify.notify('Start time must be earlier than end time');
                return;
            }
        } else if (this.state.startTime || this.state.endTime) {
            this.setState({ loading: false });
            Notify.notify('Both start time and end time must be provided');
            return;
        }

        if (formData.ttsRows.length === 0) {
            this.setState({ loading: false });
            Notify.notify('Please add TTS Rows');
            return;
        }


        if (formData.gender === '') {
            this.setState({ loading: false });
            Notify.notify('Please Select Gender');
            return;
        }

        if (formData.language == '') {
            this.setState({ loading: false });
            Notify.notify('Please Select Language');
            return;
        }

        if (formData.templateId == 9) {
            this.setState({ patchList: "" });
        }

        if (!this.state.sendSmsSuccess) {
            formData.smsApiSuccess = '';
            formData.callDurationSMS = 0;
        }
        if (!this.state.sendSmsFail) {
            formData.smsApiFail = '';
        }
        if (!this.state.sendSmsPatchSuccess) {
            formData.callPatchSuccessMessage = '';
        }
        if (!this.state.sendSmsPatchFail) {
            formData.callPatchFailMessage = '';
        }
        if (!this.state.sendSmsDtmf) {
            formData.smsApiDtmf = '';
        }
        if (this.state.smsWebhookFlag === false) {
            if (this.state.sendSmsSuccess) {
                let valueObj = {
                    url: formData.smsApiSuccess,
                    smsText: "",
                    requestType: "GET"
                }
                formData.smsApiSuccess = JSON.stringify(valueObj);
            }
            if (this.state.sendSmsFail) {
                let valueObj = {
                    url: formData.smsApiFail,
                    smsText: "",
                    requestType: "GET"
                }
                formData.smsApiFail = JSON.stringify(valueObj);

            }

            if (this.state.sendSmsPatchSuccess) {
                let valueObj = {
                    url: formData.callPatchSuccessMessage,
                    smsText: "",
                    requestType: "GET"
                }
                formData.callPatchSuccessMessage = JSON.stringify(valueObj);
            }
            if (this.state.sendSmsPatchFail) {
                let valueObj = {
                    url: formData.callPatchFailMessage,
                    smsText: "",
                    requestType: "GET"
                }
                formData.callPatchFailMessage = JSON.stringify(valueObj);

            }

            if (this.state.sendSmsDtmf) {
                let valueObj = {
                    url: formData.smsApiDtmf,
                    smsText: "",
                    requestType: "GET"
                }
                formData.smsApiDtmf = JSON.stringify(valueObj);
            }
        }

        let wId = "";
        if (this.state.sendWebhook) {
            if (this.state.webhookId !== "") {
                wId = this.state.webhookId;
            } else {
                wId = ""
            }
        }

        let lang = ""
        if (this.state.language === "English") {
            lang = "en-IN";
        } else {
            lang = "hi-IN";
        }

        if (this.state.ttsList === undefined) {
            this.setState({ loading: false });
            Notify.notify('Invalid TTS List');
            return;
        }

        console.log("^^^^^^^^^ : " + this.state.ttsList);
        const ttsFlowId = this.props.ttsFlowId;

        let ivrid = "";
        if (this.state.ivrFlag === false) {
            ivrid = "";
        } else {
            ivrid = this.state.ivrId;
        }

        console.log("noinput " + this.state.noInputId);
        console.log("menu " + this.state.menuId);
        console.log("wronginput " + this.state.wronginputId);
        console.log("thanks " + this.state.thanksId);


        const data = {
            id: ttsFlowId,
            userId: this.state.userId ?? "",
            templateId: this.state.templateId ?? "",
            ttsFlowName: this.state.ttsFlowName ?? "",
            ttsFlow: JSON.stringify({
                language: lang ?? "",
                gender: this.state.gender ?? "",
                ttsRows: this.state.ttsList ?? [],
            }),
            templateData: JSON.stringify({
                dtmf: formData.dtmf ?? "",
                welcomePId: formData.welcomeId,
                menuPId: this.state.menuId,
                noInputPId: this.state.noInputId,
                wrongInputPId: this.state.wrongInputId,
                thanksPId: this.state.thanksId,
                menuWaitTime: formData.menuWaitTime ?? "",
                rePrompt: formData.rePrompt ?? "",
                noAgentId: this.state.noAgentId,
            }),
            smsData: JSON.stringify({
                smsSuccessApi: formData.smsApiSuccess ?? "",
                smsFailApi: formData.smsApiFail ?? "",
                smsDtmfApi: formData.smsApiDtmf ?? "",
                callDurationSMS: formData.callDurationSMS ?? "",
                webhook: formData.sendWebhook ?? "",
                webhookId: wId ?? "",
                callPatchSuccessMessage: formData.callPatchSuccessMessage ?? "",
                callPatchFailMessage: formData.callPatchFailMessage ?? "",
            }),
            agentRows: this.state.patchList ? JSON.stringify(this.state.patchList) : "",
            ivrId: ivrid,
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            startTime: this.state.startTime,
            endTime: this.state.endTime
        };

        return Fetcher.post(this.props.app.apiPath + '/api/obd/update/tts/flow', {
            headers: { "Content-Type": "application/json" },
            method: 'POST',
            body: JSON.stringify(data),
        })
            .then(res => {
                let flowAdded = false;
                if (res.message === 'Parameters Incorrect') {
                    Notify.notify(res.message);
                } else {
                    Notify.notify(res.message);
                    flowAdded = true;
                }
                this.setState({
                    flowAdded: flowAdded
                })
            })
            .catch(err => {
                console.error('Error in Updating TTS Flow', err);
                Notify.notify('Error in Updating TTS Flow');
            });

    }


    handleClickPlus = () => {
        Notify.notify("You can not perform this in running campaign")
        return

        if (this.state.selectedType !== '' && this.state.selectedType === 'prompt') {

            if (this.state.selectedPromptId !== '') {

                const item = {
                    ttsType: this.state.selectedType,
                    value: this.state.selectedPromptId,
                    variableType: ''
                };

                const checkPrompt = obj => obj.value === this.state.selectedPromptId;
                this.state.ttsRows.push(item);
                this.setState({
                    ttsRows: this.state.ttsRows
                });
                this.state.ttsList = {
                    "ttsList": this.state.ttsRows
                }

            } else {
                Notify.notify("Please Select Prompt");
            }
        }
        else if (this.state.selectedType !== '' && this.state.selectedType === 'variable') {


            if (this.state.valueList.length == 0) {

                return;
            }

            if (this.state.valueList.length > 1) {
                if (this.state.valueList.length == 10) {
                    if (this.state.selectedValue > 1) {
                        Notify.notify("Please Select Lower Variable Value First.");
                        return;
                    }
                }
                else if (Number(this.state.valueList[0]) != Number(this.state.selectedValue)) {

                    Notify.notify("Please Select Lower Variable Value First..");
                    return;
                }
            }

            if (this.state.selectedValue !== '') {

                const item = {
                    ttsType: this.state.selectedType,
                    value: this.state.selectedValue,
                    variableType: this.state.variableType
                };


                this.state.ttsRows.push(item);
                this.setState({
                    ttsRows: this.state.ttsRows
                });
                this.state.ttsList = {
                    "ttsList": this.state.ttsRows
                }

                let newArr = this.state.valueList.filter(element => element != this.state.selectedValue);

                this.setState({
                    "valueList": newArr,
                    selectedValue: Number(this.state.selectedValue) + 1
                })



                if (this.state.valueList.length === 1) {
                    this.setState({
                        requiredValue: false
                    })
                }

            } else {
                Notify.notify("Please Select Variable");
            }
        }
        else {
            Notify.notify("Please Select TTS Action");
        }

    }


    getGrouName(gId) {


        for (let i = 0; i < this.state.groupAgentList.length; i++) {
            if (this.state.groupAgentList[i]["groupId"] == gId) {
                this.state.groupName = this.state.groupAgentList[i]["groupName"];
                break;
            }
            continue;
        }

    }


    handleAddRow = () => {
        if (this.state.groupId !== '' && this.state.agentDtmf !== '') {

            this.getGrouName(this.state.groupId);

            const item = {
                groupId: this.state.groupId,
                agentDtmf: this.state.agentDtmf,
                groupName: this.state.groupName
            };
            const checkDtmf = obj => obj.agentDtmf === this.state.agentDtmf;
            if (this.state.agentRows.some(checkDtmf)) {
                Notify.notify(this.state.agentDtmf + ' DTMF is already selected');
                return;
            }
            this.state.agentRows.push(item);
            this.setState({
                agentRows: this.state.agentRows
            });
            this.state.patchList = {
                "patchList": this.state.agentRows
            }
        }
        else {
            Notify.notify("Please select Agent Group and DTMF");
        }
    };


    handleRemoveRow = () => {
        this.setState({
            agentRows: this.state.agentRows.slice(0, -1)
        });
    };

    handleRemoveTTSRow = (index) => {
        Notify.notify("You can not perform this in running campaign")
        return

        let arr1 = this.state.ttsRows;
        let arr2 = this.state.ttsRows.splice(index, 1);
        let arr3 = [];
        for (let i = 0; i < arr1.length; i++) {
            arr3.push(arr1[i]);
        }
        this.setState({
            ttsRows: arr3
        });
        let ttsval = arr2[0].value;
        this.state.valueList.push(ttsval);
        this.state.valueList.sort((a, b) => a - b);
        this.setState({
            selectedValue: this.state.valueList[0]
        });
    };


    addZero = (i) => {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    }


    sendLaterDateChange = date => {
        this.setState({
            startDate: date
        });
    };

    sendLaterDateChange1 = date => {
        this.setState({
            endDate: date
        });
    };

    render() {
        if (this.state.flowAdded === true) {
            return <Redirect to='/tts-flow-list' />
        }
        let submitButtonlabel = 'Update';

        let welcomeDropdown = '';
        let menuDropdown = '';
        let noinputDropdown = '';
        let wronginputDropdown = '';
        let thanksDropdown = '';
        let ttsDropdown = '';
        let ttsValueDropDown = '';
        let noAgentDropdown = '';
        let ttsTypeDropdown = '';
        let welcomeMenuDropdown = '';

        const valList = cloneDeep(this.state.valueList);
        if (!isEmpty(valList) && !("error" in valList)) {
            const max = Number(this.state.totalVariable);

            const filteredList = max > 0
                ? valList.filter((v) => Number(v) <= max)
                : [];

            ttsValueDropDown = filteredList.map((fileObj, index) => (
                <option value={fileObj} key={`ttsValue${index}`}>
                    {fileObj}
                </option>
            ));
        }

        const typeTTSList = cloneDeep(this.state.ttsTypeListApi);
        if (!isEmpty(typeTTSList) && (!('error' in typeTTSList))) {

            ttsTypeDropdown = Array.isArray(typeTTSList) ? typeTTSList.map((fileObj, index) => {

                return <option value={fileObj.tts_type} key={`ttsType${index}`} >{fileObj.tts_type}</option>

            }) : [];

        } else {
            ttsTypeDropdown = <p>No TTS Type found</p>;
        }

        const promptUploads = cloneDeep(this.state.promptUploads);

        if (!isEmpty(promptUploads) && (!('error' in promptUploads))) {

            welcomeDropdown = promptUploads.map((fileObj, index) => {
                if (fileObj.promptCategory === 'welcome' && fileObj.promptStatus != 9) {
                    return <option value={fileObj.promptId} key={`promptfile${index}`} >{fileObj.fileName}</option>
                }
                else {
                    welcomeDropdown = <option value="" >No Files</option>
                }
            })

            welcomeMenuDropdown = promptUploads.map((fileObj, index) => {
                if ((fileObj.promptCategory === 'welcome' || fileObj.promptCategory === 'menu') && fileObj.promptStatus === 1) {
                    return <option value={fileObj.promptId} key={`promptfile${index}`} >{fileObj.fileName}</option>
                }
                else {
                    welcomeMenuDropdown = <option value="" >No Files</option>
                }
            })

            menuDropdown = promptUploads.map((fileObj, index) => {
                if (fileObj.promptCategory === 'menu' && fileObj.promptStatus === 1) {
                    return <option value={fileObj.promptId} key={`promptfile${index}`} >{fileObj.fileName}</option>
                }
                else {
                    menuDropdown = <option value="" >No Files</option>
                }
            })

            noinputDropdown = promptUploads.map((fileObj, index) => {
                if (fileObj.promptCategory === 'noinput' && fileObj.promptStatus === 1) {
                    return <option value={fileObj.promptId} key={`promptfile${index}`} >{fileObj.fileName}</option>
                }
                else {
                    noinputDropdown = <option value="" >No Files</option>
                }
            })

            wronginputDropdown = promptUploads.map((fileObj, index) => {
                if (fileObj.promptCategory === 'wronginput' && fileObj.promptStatus === 1) {
                    return <option value={fileObj.promptId} key={`promptfile${index}`} >{fileObj.fileName}</option>
                }
                else {
                    wronginputDropdown = <option value="" >No Files</option>
                }
            })

            thanksDropdown = promptUploads.map((fileObj, index) => {
                if (fileObj.promptCategory === 'thanks' && fileObj.promptStatus === 1) {
                    return <option value={fileObj.promptId} key={`promptfile${index}`} >{fileObj.fileName}</option>
                }
                else {
                    thanksDropdown = <option value="" >No Files</option>
                }
            })

            ttsDropdown = promptUploads.map((fileObj, index) => {
                if (fileObj.promptCategory === 'tts' && fileObj.promptStatus === 1) {
                    return <option value={fileObj.promptId} key={`promptfile${index}`} >{fileObj.fileName}</option>
                }
                else {
                    ttsDropdown = <option value="" >No Files</option>
                }
            })

            noAgentDropdown = promptUploads.map((fileObj, index) => {
                if (fileObj.promptCategory === 'noagent' && fileObj.promptStatus === 1) {
                    return <option value={fileObj.promptId} key={`promptfile${index}`} >{fileObj.fileName}</option>
                }
                else {
                    noAgentDropdown = <option value="" >No Files</option>
                }
            })
        }

        const agentRows = cloneDeep(this.state.agentRows);
        const agentsTable = agentRows.map((item, index) => {
            return <tr key={index}>
                <td>{this.state.agentRows[index].groupName}</td>
                <td>{this.state.agentRows[index].agentDtmf}</td>
                <td>
                    <i onClick={() => this.handleRemoveRow()} className="fa fa-minus-circle"></i>
                </td>
            </tr>;
        });

        const gAList = cloneDeep(this.state.groupAgentList);
        let groupAgentDropdown = '';
        if (!isEmpty(gAList) && (!('error' in gAList))) {
            groupAgentDropdown = Array.isArray(gAList) ? gAList.map((obj, index) => {
                return (
                    <option value={obj.groupId} key={`groupAgent${index}`} >{obj.groupName}</option>
                );
            }) : [];
        } else {
            groupAgentDropdown = <p>No Group found</p>;
        }

        const ttsRows = cloneDeep(this.state.ttsRows);
        const ttsTable = ttsRows.map((item, index) => {
            return <tr key={index}>
                <td>{this.state.ttsRows[index].ttsType}</td>
                <td>{this.state.ttsRows[index].value}</td>
                <td>{this.state.ttsRows[index].variableType}</td>
                <td>
                    <i onClick={() => this.handleRemoveTTSRow(index)} className="fa fa-minus-circle"></i>
                </td>
            </tr>;
        });

        const smsWebhookList = cloneDeep(this.state.smsWebhookList);
        let smsWebhookDropdown = '';
        if (!isEmpty(smsWebhookList) && (!('error' in smsWebhookList))) {
            smsWebhookDropdown = Array.isArray(smsWebhookList) ? smsWebhookList.map((obj, index) => {
                let valueObj = {
                    url: obj.url,
                    smsText: obj.smsText,
                    requestType: obj.requestType,
                    payload: obj.payload,
                    header : obj.header
                }
                return <option value={JSON.stringify(valueObj)} key={`eventid${index}`} >{obj.webhookName}</option>
            }) : []

        } else {
            smsWebhookDropdown = <option value="" >No Sms Webhook found</option>
        }


        const webhookList = cloneDeep(this.state.webhookList);
        let webhookDropdown = '';
        if (!isEmpty(webhookList) && (!('error' in webhookList))) {
            webhookDropdown = Array.isArray(webhookList) ? webhookList.map((obj, index) => {
                return <option value={obj.id} key={`id${index}`} >{obj.webhookName}</option>
            }) : []

        } else {
            webhookDropdown = <option value="" >No Webhook found</option>
        }

        let ivrDropdown = '';
        const ivrList = this.state.ivrList;

        if (!isEmpty(ivrList) && (!('error' in ivrList))) {
                           const activeIvrs = ivrList.filter(item => item.status === "1");
                           ivrDropdown = Array.isArray(activeIvrs)?activeIvrs.map((fileObj, index) => {
                               return <option value={fileObj.id} key={`basefile${fileObj.id}`} >{fileObj.flowName}</option>
                           }):[]
               
               } else {
                           ivrDropdown = <option value="" >No Files</option>
        }

        let sendLaterDatepicker = '';
        sendLaterDatepicker = <Row>
            <Form.Group controlId="start-date">
                <Form.Label>Enter Start Date</Form.Label>
                <DatePicker
                    className="form-control"
                    minDate={new Date()}
                    selected={(this.state.startDate)}
                    dateFormat="yyyy-MM-dd"
                    onChange={this.sendLaterDateChange}
                />
            </Form.Group>
            <label for="startTime">Select Daily Start Time:</label>
            <input type="time" id="startTime" name="startTime" onChange={e => this.setvalue(e)} value={this.state.startTime}></input>
        </Row>



        let sendLaterDatepicker1 = '';

        sendLaterDatepicker1 = <Row>
            <Form.Group controlId="end-date">
                <Form.Label>Enter End Date</Form.Label>
                <DatePicker
                    className="form-control"
                    minDate={new Date()}
                    selected={(this.state.endDate == '' ? new Date() : this.state.endDate)}
                    timeCaption="Time"
                    dateFormat="yyyy-MM-dd"
                    onChange={this.sendLaterDateChange1}
                />
            </Form.Group>
            <label for="endTime">Select Daily End Time:</label>
            <input type="time" id="endTime" name="endTime" onChange={e => this.setvalue(e)} value={this.state.endTime}></input>
        </Row>

        return (

            <Form className="add-tts-flow-form" onSubmit={(e) => this.handleUpdateTTSFlow(e)}>
                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Header>Update TTS Flow</Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col sm={3}>
                                        <Form.Group className="form-group required control-label">
                                            <Form.Select disabled={true} className="dd" required name="templateId" onChange={e => this.setvalue(e)} as="select">
                                                <option value={this.state.templateId}>{this.state.templateIdValue}</option>
                                                <option value="7">TTS Simple IVR</option>
                                                <option value="8">TTS DTMF</option>
                                                <option value="9">TTS Call Patch</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col sm={3}>
                                        <Form.Group className="form-group" controlId="tts-flow-name">
                                            <Form.Control readOnly name="ttsFlowName" onChange={e => this.setvalue(e)} value={this.state.ttsFlowName} type="text" placeholder="Flow Name" />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Group className="form-group required control-label">
                                            <Form.Select className="dd" required name="language" onChange={e => this.setvalue(e)} as="select" disabled={this.state.inputDisabilty}>
                                                <option value={this.state.language}>{this.state.language}</option>
                                                <option value="English">English</option>
                                                <option value="Hindi">Hindi</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Group className="form-group required control-label">
                                            <Form.Select className="dd" required name="gender" onChange={e => this.setvalue(e)} as="select" disabled={this.state.inputDisabilty}>
                                                <option value={this.state.gender}>{this.state.gender}</option>
                                                <option value="MALE">MALE</option>
                                                <option value="FEMALE">FEMALE</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>


                                <Row>
                                    <Col sm={3}>
                                        <Form.Group className="form-group" controlId="sender-id">
                                            <Form.Select required name="selectedType" onChange={e => this.setvalue(e)} value={this.state.selectedType} as="select">
                                                <option value="">Select Type</option>
                                                <option value="variable">Variable</option>
                                                <option value="prompt">Prompt</option>

                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    {((this.state.templateId === '7') && this.state.selectedType === 'prompt') &&
                                        <Col sm={3}>
                                            <Form.Select as="select" required name="selectedPromptId" onChange={e => this.setvalue(e)}>
                                                <option value="">Select Prompt</option>
                                                {welcomeDropdown}
                                            </Form.Select>
                                        </Col>

                                    }

                                    {((this.state.templateId === '8' || this.state.templateId === '9') && this.state.selectedType === 'prompt') &&

                                        <Col sm={3}>
                                            <Form.Select as="select" required name="selectedPromptId" onChange={e => this.setvalue(e)}>
                                                <option value="">Select Prompt</option>
                                                {welcomeMenuDropdown}
                                            </Form.Select>
                                        </Col>

                                    }

                                    {((this.state.templateId === '7' || this.state.templateId === '8' || this.state.templateId === '9') && this.state.selectedType === 'variable') &&
                                        <Col sm={3}>
                                            <Form.Select as="select" required={this.state.requiredValue} name="selectedValue" onChange={e => this.setvalue(e)}>
                                                {/* <option value={this.state.valueList[0]}>{this.state.valueList[0]}</option> */}
                                                <option value="">Select Variable</option>
                                                {ttsValueDropDown}
                                            </Form.Select>
                                        </Col>

                                    }

                                    {((this.state.templateId === '7' || this.state.templateId === '8' || this.state.templateId === '9') && this.state.selectedType === 'variable') &&
                                        <Col sm={3}>
                                            <Form.Group className="form-group" controlId="sender-id">
                                                <Form.Select required name="variableType" onChange={e => this.setvalue(e)} value={this.state.variableType} as="select">
                                                    <option value="text">text</option>
                                                    {ttsTypeDropdown}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    }

                                    {((this.state.templateId === '7' || this.state.templateId === '8' || this.state.templateId === '9') && this.state.selectedType != '') &&
                                        <Col sm={3}>
                                            <i onClick={this.handleClickPlus} className="fa fa-plus-circle plus-icon"></i>
                                        </Col>
                                    }


                                </Row>

                                {(this.state.templateId === '7' || this.state.templateId === '8' || this.state.templateId === '9') && <Row>
                                    <Col sm={6}>
                                        <div className="react-bootstrap-table">

                                            <table className="table table-striped table-bordered table-sm widgetlist-table">
                                                <thead>
                                                    <tr>
                                                        <th>Type</th>
                                                        <th>Value</th>
                                                        <th>Variable Type</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ttsTable}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>

                                </Row>}
                                
                                {this.state.campaignIds && this.state.campaignIds.trim() !== '' && (
                                <Row>
                                    <Col sm={6}>
                                        <Card className="mb-3">
                                        <Card.Body>
                                            <Row>
                                                <Form.Label>Campaign Ids: </Form.Label>
                                            <Col>
                                                <div className="tag-input-container gap-2 d-flex w-fit flex-wrap">
                                                    {this.state.campaignIds
                                                    .split(",")
                                                    .map(id => id.trim())
                                                    .filter(id => id !== '')
                                                    .map((campaignId, index) => (
                                                        <span key={index} className="badge badge-danger tag">
                                                        {campaignId}
                                                        </span>
                                                    ))}
                                                </div>
                                            </Col>
                                            </Row>
                                        </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                )}

                                {((this.state.templateId === '8')) &&
                                    <Row>
                                        <Col sm={6}>
                                            <Form.Group className="form-group" controlId="sender-id">
                                                <Form.Label>Select DTMF</Form.Label>
                                                <Form.Select required name="dtmf" onChange={(e) => { this.handleSelect(e.target.selectedOptions) }} multiple as="select">
                                                    <option selected value={this.state.dtmf}>{this.state.dtmf}</option>
                                                    <option value="0">0</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>}

                                {(this.state.templateId === '8' || this.state.templateId === '9') && <Row>
                                    <Col sm={4}>
                                        <Form.Label>Upload Menu Wav File</Form.Label>
                                        <Form.Group className="form-group" >
                                            <Form.Select as="select" required name="menuId" onChange={e => this.setvalue(e)}>
                                                <option value={this.state.menuId}>{this.getPromptName(this.state.menuId)}</option>
                                                {menuDropdown}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4}>
                                        <Form.Label>Menu Wait Time</Form.Label>
                                        <Form.Group className="form-group" >
                                            <Form.Select required name="menuWaitTime" onChange={e => this.setvalue(e)} value={this.state.menuWaitTime} as="select">
                                                <option value={this.state.menuWaitTime}>{this.state.menuWaitTime}</option>
                                                <option value="0">0</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4}>
                                        <Form.Label>Re-Prompt</Form.Label>
                                        <Form.Group className="form-group" >
                                            <Form.Select required name="rePrompt" onChange={e => this.setvalue(e)} value={this.state.rePrompt} as="select">
                                                <option value={this.state.rePrompt}>{this.state.rePrompt}</option>
                                                <option value="0">0</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>}

                                {(this.state.templateId === '8') && <Row>
                                    <Col sm={6}>
                                        <Form.Group className="form-group" controlId="welcome-prompt">
                                            <Form.Check checked={this.state.noinputPrompt} onChange={(e) => this.toggleChange(e, 'noinputPrompt')} custom inline name="noinputPrompt" label="Noinput File" id="noinputPrompt" type="checkbox" />
                                            <Form.Check checked={this.state.wronginputPrompt} onChange={(e) => this.toggleChange(e, 'wronginputPrompt')} custom inline name="wronginputPrompt" label="Wronginput File" id="wronginputPrompt" type="checkbox" />
                                            <Form.Check checked={this.state.thanksPrompt} onChange={(e) => this.toggleChange(e, 'thanksPrompt')} custom inline name="thanksPrompt" label="Thanks File" id="thanksPrompt" type="checkbox" />
                                        </Form.Group>
                                    </Col>
                                </Row>}

                                {(this.state.templateId === '9') && <Row>
                                    <Col sm={6}>
                                        <Form.Group className="form-group" controlId="welcome-prompt">
                                            <Form.Check checked={this.state.noinputPrompt} onChange={(e) => this.toggleChange(e, 'noinputPrompt')} custom inline name="noinputPrompt" label="Noinput File" id="noinputPrompt" type="checkbox" />
                                            <Form.Check checked={this.state.wronginputPrompt} onChange={(e) => this.toggleChange(e, 'wronginputPrompt')} custom inline name="wronginputPrompt" label="Wronginput File" id="wronginputPrompt" type="checkbox" />
                                            <Form.Check checked={this.state.thanksPrompt} onChange={(e) => this.toggleChange(e, 'thanksPrompt')} custom inline name="thanksPrompt" label="Thanks File" id="thanksPrompt" type="checkbox" />
                                            <Form.Check required checked={this.state.noAgentPrompt} onChange={(e) => this.toggleChange(e, 'noAgentPrompt')} custom inline name="noAgentPrompt" label="No Agent File" id="noAgentPrompt" type="checkbox" />
                                        </Form.Group>
                                    </Col>
                                </Row>}

                                {(this.state.welcomePrompt) && <Row>
                                    <Col sm={6}>
                                        <Form.Label>Upload Welcome Wav File</Form.Label>
                                        <Form.Group className="form-group" >
                                            <Form.Select as="select" name="welcomeId" onChange={e => this.setvalue(e)}>
                                                <option value={this.state.welcomeId}>{this.getPromptName(this.state.welcomeId)}</option>
                                                {welcomeDropdown}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>}

                                {(this.state.noinputPrompt) && <Row>
                                    <Col sm={6}>
                                        <Form.Label>Upload Noinput Wav File</Form.Label>
                                        <Form.Group className="form-group" >
                                            <Form.Select as="select" name="noInputId" onChange={e => this.setvalue(e)}>
                                                <option value={this.state.noInputId}>{(this.state.noInputId == "") ?  "Select File" :  this.getPromptName(this.state.noInputId)}</option>
                                                {noinputDropdown}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>}

                                {(this.state.wronginputPrompt) && <Row>
                                    <Col sm={6}>
                                        <Form.Label>Upload Wronginput Wav File</Form.Label>
                                        <Form.Group className="form-group" >
                                            <Form.Select as="select" name="wronginputId" onChange={e => this.setvalue(e)}>
                                                <option value={this.state.wrongInputId}>{(this.state.wrongInputId == "") ? "Select File" : this.getPromptName(this.state.wrongInputId)}</option>
                                                {wronginputDropdown}
                                            </Form.Select>
                                        </Form.Group>

                                    </Col>
                                </Row>}

                                {(this.state.thanksPrompt) && <Row>
                                    <Col sm={6}>
                                        <Form.Label>Upload Thanks Wav File</Form.Label>
                                        <Form.Group className="form-group" >
                                            <Form.Select as="select" name="thanksId" onChange={e => this.setvalue(e)}>
                                                <option value={this.state.thanksId}>{ (this.state.thanksId == "") ? "Select File" :  this.getPromptName(this.state.thanksId)}</option>
                                                {thanksDropdown}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>}

                                {(this.state.noAgentPrompt) && <Row>
                                    <Col sm={6}>
                                        <Form.Label>Upload No Agent Wav File</Form.Label>
                                        <Form.Group className="form-group" >
                                            <Form.Select as="select" required name="noAgentId" onChange={e => this.setvalue(e)}>
                                                <option value={this.state.noAgentId}>{(this.state.noAgentId == "") ? "Select File" : this.getPromptName(this.state.noAgentId)}</option>
                                                {noAgentDropdown}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>}

                                {(this.state.templateId === '9') && <Row>
                                    <Col sm={6}>
                                        <Form.Group className="form-group"  ><Form.Label>Add Agents</Form.Label></Form.Group>
                                    </Col>
                                </Row>}

                                {(this.state.templateId === '9') &&
                                    <Row>
                                        <Col sm={6}>
                                            <Form.Group className="form-group" >
                                                <Form.Select as="select" name="groupId" onChange={e => this.setvalue(e)}>
                                                    <option value="">Select Group</option>
                                                    {groupAgentDropdown}
                                                </Form.Select>
                                            </Form.Group>

                                        </Col>

                                        <Col sm={2}>
                                            <Form.Group className="form-group" controlId="sender-id">
                                                <Form.Select required name="agentDtmf" onChange={e => this.setvalue(e)} value={this.state.agentDtmf} as="select">
                                                    <option value="0">0</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <i onClick={this.handleAddRow} className="fa fa-plus-circle plus-icon"></i>
                                        </Col>
                                    </Row>}
                                {(this.state.templateId === '9') && <Row>
                                    <Col sm={6}>
                                        <div className="react-bootstrap-table">
                                            <table className="table table-striped table-bordered table-sm widgetlist-table">
                                                <thead>
                                                    <tr>
                                                        <th>Group</th>
                                                        <th>DTMF</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {agentsTable}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>}


                                {(this.state.templateId === '7' || this.state.templateId === '8' || this.state.templateId === '9') && <Row>
                                    <Row>
                                        <Col sm={3}>
                                            <Form.Group className="form-group" controlId="Send-Sms">
                                                <Form.Check checked={this.state.sendSmsSuccess} onChange={(e) => this.toggleChange(e, 'sendSmsSuccess')} custom inline name="sendSmsSuccess" label="Send SMS on Success" id="sendSmsSuccess" type="checkbox" />
                                            </Form.Group>
                                        </Col>
                                        {(this.state.sendSmsSuccess && (this.state.smsWebhookFlag === false)) &&
                                            <Col sm={3}>
                                                <Form.Group className="form-group" controlId="sender-id">
                                                    <Form.Select required name="callDurationSMS" onChange={e => this.setvalue(e)} value={this.state.callDurationSMS} as="select">
                                                        <option value="">Select Duration</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                        <option value="6">6</option>
                                                        <option value="7">7</option>
                                                        <option value="8">8</option>
                                                        <option value="9">9</option>
                                                        <option value="10">10</option>
                                                        <option value="11">11</option>
                                                        <option value="12">12</option>
                                                        <option value="13">13</option>
                                                        <option value="14">14</option>
                                                        <option value="15">15</option>
                                                        <option value="16">16</option>
                                                        <option value="17">17</option>
                                                        <option value="18">18</option>
                                                        <option value="19">19</option>
                                                        <option value="20">20</option>
                                                        <option value="21">21</option>
                                                        <option value="22">22</option>
                                                        <option value="23">23</option>
                                                        <option value="24">24</option>
                                                        <option value="25">25</option>
                                                        <option value="26">26</option>
                                                        <option value="27">27</option>
                                                        <option value="28">28</option>
                                                        <option value="29">29</option>
                                                        <option value="30">30</option>
                                                        <option value="31">31</option>
                                                        <option value="32">32</option>
                                                        <option value="33">33</option>
                                                        <option value="34">34</option>
                                                        <option value="35">35</option>
                                                        <option value="36">36</option>
                                                        <option value="37">37</option>
                                                        <option value="38">38</option>
                                                        <option value="39">39</option>
                                                        <option value="40">40</option>
                                                        <option value="41">41</option>
                                                        <option value="42">42</option>
                                                        <option value="43">43</option>
                                                        <option value="44">44</option>
                                                        <option value="45">45</option>
                                                        <option value="46">46</option>
                                                        <option value="47">47</option>
                                                        <option value="48">48</option>
                                                        <option value="49">49</option>
                                                        <option value="50">50</option>
                                                        <option value="51">51</option>
                                                        <option value="52">52</option>
                                                        <option value="53">53</option>
                                                        <option value="54">54</option>
                                                        <option value="55">55</option>
                                                        <option value="56">56</option>
                                                        <option value="57">57</option>
                                                        <option value="58">58</option>
                                                        <option value="59">59</option>
                                                        <option value="50">60</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>}

                                        {(this.state.sendSmsSuccess && (this.state.smsWebhookFlag === true)) && <>
                                            <Col sm={3}>
                                                <Form.Group className="form-group" controlId="sender-id">
                                                    <Form.Select required name="callDurationSMS" onChange={e => this.setvalue(e)} value={this.state.callDurationSMS} as="select">
                                                        <option value="">Select Duration</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                        <option value="6">6</option>
                                                        <option value="7">7</option>
                                                        <option value="8">8</option>
                                                        <option value="9">9</option>
                                                        <option value="10">10</option>
                                                        <option value="11">11</option>
                                                        <option value="12">12</option>
                                                        <option value="13">13</option>
                                                        <option value="14">14</option>
                                                        <option value="15">15</option>
                                                        <option value="16">16</option>
                                                        <option value="17">17</option>
                                                        <option value="18">18</option>
                                                        <option value="19">19</option>
                                                        <option value="20">20</option>
                                                        <option value="21">21</option>
                                                        <option value="22">22</option>
                                                        <option value="23">23</option>
                                                        <option value="24">24</option>
                                                        <option value="25">25</option>
                                                        <option value="26">26</option>
                                                        <option value="27">27</option>
                                                        <option value="28">28</option>
                                                        <option value="29">29</option>
                                                        <option value="30">30</option>
                                                        <option value="31">31</option>
                                                        <option value="32">32</option>
                                                        <option value="33">33</option>
                                                        <option value="34">34</option>
                                                        <option value="35">35</option>
                                                        <option value="36">36</option>
                                                        <option value="37">37</option>
                                                        <option value="38">38</option>
                                                        <option value="39">39</option>
                                                        <option value="40">40</option>
                                                        <option value="41">41</option>
                                                        <option value="42">42</option>
                                                        <option value="43">43</option>
                                                        <option value="44">44</option>
                                                        <option value="45">45</option>
                                                        <option value="46">46</option>
                                                        <option value="47">47</option>
                                                        <option value="48">48</option>
                                                        <option value="49">49</option>
                                                        <option value="50">50</option>
                                                        <option value="51">51</option>
                                                        <option value="52">52</option>
                                                        <option value="53">53</option>
                                                        <option value="54">54</option>
                                                        <option value="55">55</option>
                                                        <option value="56">56</option>
                                                        <option value="57">57</option>
                                                        <option value="58">58</option>
                                                        <option value="59">59</option>
                                                        <option value="50">60</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            <Col sm={3}>
                                                <Form.Group className="form-group required control-label">
                                                    <Form.Select className="dd" required name="smsApiSuccess" onChange={e => this.setvalue(e)} as="select">
                                                        <option value="">Select SMS Webhook</option>
                                                        {smsWebhookDropdown}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                        </>
                                        }

                                        {(this.state.sendSmsSuccess && (this.state.smsWebhookFlag === false)) && <Row>
                                            <Col sm={6}>
                                                <Form.Group className="form-group"  >
                                                    <Form.Label> Note: Please Paste the SMS API here and replace the Mobile No. with &#123;PHONE&#125; </Form.Label>
                                                    <Form.Control required value={this.state.smsApiSuccess} onChange={e => this.setvalue(e)} name="smsApiSuccess" as="textarea" rows="2" />
                                                </Form.Group>
                                            </Col>
                                        </Row>}
                                    </Row>
                                </Row>}

                                {(this.state.templateId === '7' || this.state.templateId === '8' || this.state.templateId === '9') && <Row>
                                    <Row>
                                        <Col sm={3}>
                                            <Form.Group className="form-group" controlId="Send-Sms">
                                                <Form.Check checked={this.state.sendSmsFail} onChange={(e) => this.toggleChange(e, 'sendSmsFail')} custom inline name="sendSmsFail" label="Send SMS on Fail" id="sendSmsFail" type="checkbox" />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {(this.state.sendSmsFail && this.state.smsWebhookFlag === true) &&
                                        <Col sm={3}>
                                            <Form.Group className="form-group required control-label">
                                                <Form.Select className="dd" required name="smsApiFail" onChange={e => this.setvalue(e)} as="select">
                                                    <option value="">Select SMS Webhook</option>
                                                    {smsWebhookDropdown}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    }

                                    {(this.state.sendSmsFail && this.state.smsWebhookFlag === false) && <Row>
                                        <Col sm={6}>
                                            <Form.Group className="form-group"  >
                                                <Form.Label>Note: Please Paste the SMS API here and replace the Mobile No. with &#123;PHONE&#125; </Form.Label>
                                                <Form.Control required value={this.state.smsApiFail} onChange={e => this.setvalue(e)} name="smsApiFail" as="textarea" rows="2" />
                                            </Form.Group>
                                        </Col>
                                    </Row>}
                                </Row>}

                                {this.state.templateId === '9' && <Row>
                                    <Row>
                                        <Col sm={3}>
                                            <Form.Group className="form-group" controlId="Send-Sms">
                                                <Form.Check checked={this.state.sendSmsPatchSuccess} onChange={(e) => this.toggleChange(e, 'sendSmsPatchSuccess')} custom inline name="sendSmsPatchSuccess" label="Send SMS to Agent on Patch Success" id="sendSmsPatchSuccess" type="checkbox" />
                                            </Form.Group>
                                        </Col>

                                        {(this.state.sendSmsPatchSuccess && this.state.smsWebhookFlag === true) &&
                                            <Col sm={3}>
                                                <Form.Group className="form-group required control-label">
                                                    <Form.Select className="dd" required name="callPatchSuccessMessage" onChange={e => this.setvalue(e)} as="select">
                                                        <option value="">Select SMS Webhook</option>
                                                        {smsWebhookDropdown}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        }

                                    </Row>



                                    {(this.state.sendSmsPatchSuccess && this.state.smsWebhookFlag === false) && <Row>
                                        <Col sm={6}>
                                            <Form.Group className="form-group"  >
                                                <Form.Label>Note: Please Paste the SMS API here and replace the Mobile No. with &#123;PHONE&#125; </Form.Label>
                                                <Form.Control required value={this.state.callPatchSuccessMessage} onChange={e => this.setvalue(e)} name="callPatchSuccessMessage" as="textarea" rows="2" />
                                            </Form.Group>
                                        </Col>

                                    </Row>}


                                </Row>}

                                {this.state.templateId === '9' && <Row>
                                    <Row>
                                        <Col sm={3}>
                                            <Form.Group className="form-group" controlId="Send-Sms">
                                                <Form.Check checked={this.state.sendSmsPatchFail} onChange={(e) => this.toggleChange(e, 'sendSmsPatchFail')} custom inline name="sendSmsPatchFail" label="Send SMS to Agent on Patch Fail" id="sendSmsPatchFail" type="checkbox" />
                                            </Form.Group>
                                        </Col>


                                        {(this.state.sendSmsPatchFail && this.state.smsWebhookFlag === true) &&
                                            <Col sm={3}>
                                                <Form.Group className="form-group required control-label">
                                                    <Form.Select className="dd" required name="callPatchFailMessage" onChange={e => this.setvalue(e)} as="select">
                                                        <option value="">Select SMS Webhook</option>
                                                        {smsWebhookDropdown}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        }
                                    </Row>
                                    {(this.state.sendSmsPatchFail && this.state.smsWebhookFlag === false) && <Row>
                                        <Col sm={6}>
                                            <Form.Group className="form-group"  >
                                                <Form.Label>Note: Please Paste the SMS API here and replace the Mobile No. with &#123;PHONE&#125; </Form.Label>
                                                <Form.Control required value={this.state.callPatchFailMessage} onChange={e => this.setvalue(e)} name="callPatchFailMessage" as="textarea" rows="2" />
                                            </Form.Group>
                                        </Col>

                                    </Row>}



                                </Row>}

                                {(this.state.templateId === '8' || this.state.templateId === "9") && <Row>
                                    <Row>
                                        <Col sm={3}>
                                            <Form.Group className="form-group" controlId="Send-Sms">
                                                <Form.Check checked={this.state.sendSmsDtmf} onChange={(e) => this.toggleChange(e, 'sendSmsDtmf')} custom inline name="sendSmsDtmf" label="Send SMS on DTMF" id="sendSmsDtmf" type="checkbox" />
                                            </Form.Group>
                                        </Col>

                                        {(this.state.sendSmsDtmf && this.state.smsWebhookFlag === true) &&

                                            <Col sm={3}>
                                                <Form.Group className="form-group required control-label">
                                                    <Form.Select className="dd" required name="smsApiDtmf" onChange={e => this.setvalue(e)} as="select">
                                                        <option value="">Select SMS Webhook</option>
                                                        {smsWebhookDropdown}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        }


                                    </Row>
                                    {(this.state.sendSmsDtmf && this.state.smsWebhookFlag === false) && <Row>
                                        <Col sm={6}>
                                            <Form.Group className="form-group"  >
                                                <Form.Label>Note: Please Paste the SMS API here and replace the Mobile No. with &#123;PHONE&#125; </Form.Label>
                                                <Form.Control required value={this.state.smsApiDtmf} onChange={e => this.setvalue(e)} name="smsApiDtmf" as="textarea" rows="2" />
                                            </Form.Group>
                                        </Col>

                                    </Row>}

                                </Row>}

                                <Row>
                                    <Col sm={3}>{sendLaterDatepicker} </Col>
                                    <Col sm={3}>{sendLaterDatepicker1} </Col>
                                </Row>

                                {(this.state.webhookFlag) &&
                                    <Row>
                                        <Col sm={3}>
                                            <Form.Group controlId="Send-later">
                                                <Form.Check checked={this.state.sendWebhook} onChange={(e) => this.toggleChange(e, 'sendWebhook')} custom inline name="send-webhook" label="Enable Webhook" id="send-webhook" type="checkbox" />
                                            </Form.Group>
                                        </Col>

                                        {(this.state.sendWebhook) &&
                                            <Col sm={3}>
                                                <Form.Group controlId="sender-id">
                                                    <Form.Select required name="webhookId" onChange={e => this.setvalue(e)} value={this.state.webhookId} as="select">
                                                        <option value={this.state.webhookId}>{(this.state.webhookId =="")? "Select Webhook" : this.getWebhookName(this.state.webhookId)}</option>
                                                        {webhookDropdown}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>}
                                    </Row>
                                }


                                {(this.state.customIvrFlag) &&
                                    <Row>
                                        <Col sm={3}>
                                            <Form.Group controlId="Send-later">
                                                <Form.Check checked={this.state.ivrFlag} onChange={(e) => this.toggleChange(e, 'ivrFlag')} custom inline name="custom-ivr" label="Custom IVR" id="custom-ivr" type="checkbox" />
                                            </Form.Group>
                                        </Col>

                                        {(this.state.ivrFlag) &&
                                            <Col sm={3}>
                                                <Form.Group controlId="sender-id">
                                                    <Form.Select required name="ivrId" onChange={e => this.setvalue(e)} value={this.state.ivrId} as="select">
                                                        <option value={this.state.ivrId}>{(this.state.ivrId=="") ? "Select Custom IVR" :  this.getIVRName(this.state.ivrId)}</option>

                                                        {ivrDropdown}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>}
                                    </Row>
                                }
                               
                                <Button variant="primary" type="submit">{submitButtonlabel}</Button>
                            </Card.Body>
                        </Card>

                    </Col>
                </Row>
            </Form>
        );
    }
}

export default UpdateTTSFlow;